import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { OrderableQualifier, IngredientChoice, OrderableIngredient, SizePrice } from 'ngx-web-api';

@Component({
  selector: 'fts-single-ingredient-choice',
  templateUrl: './single-ingredient-choice.component.html',
  styleUrls: ['./single-ingredient-choice.component.scss'],
})
export class SingleIngredientChoiceComponent implements OnInit, OnChanges {
  hasQualifiers: boolean;
  selectedIngredient: OrderableIngredient;
  qualifiers: string[] = [];
  orderableQualifiers: OrderableQualifier[] = [];

  @Input()
  unsatisfiedIngredientChoice: IngredientChoice;
  @Input()
  selectedSizePrice: SizePrice;
  @Output()
  ingredientChange: EventEmitter<OrderableIngredient> = new EventEmitter();
  @Output()
  qualifierChange: EventEmitter<string[]> = new EventEmitter();

  @ViewChild('choiceWrap', { static: false })
  choiceWrapRef: ElementRef;

  ngOnInit() {
    this.selectedIngredient = this.unsatisfiedIngredientChoice.ingredients.find(i => i.isDefault);
    const hasAvailableSizePrice = this.selectedIngredient
      ? this.selectedIngredient.sizePrices.some(size => size.size === this.selectedSizePrice.size)
      : false;
    if (hasAvailableSizePrice) {
      this.hasQualifiers = this.selectedIngredient ? this.selectedIngredient.qualifiers.length > 0 : undefined;
      this.qualifiers = this.getDefaultQualifiers(this.selectedIngredient);
      this.qualifierChange.emit(this.qualifiers);
      this.orderableQualifiers = this.getDefaultQualifiers(this.selectedIngredient, true);
    } else {
      this.selectedIngredient = null;
    }
    this.ingredientChange.emit(this.selectedIngredient);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedSizePrice) {
      if (!this.selectedIngredient) {
        this.selectedIngredient = this.unsatisfiedIngredientChoice.ingredients.find(i => i.isDefault);
      }
      if (this.selectedIngredient) {
        const hasAvailableSizePrice = this.selectedIngredient.sizePrices.some(size => size.size === this.selectedSizePrice.size);
        this.selectedIngredient = !hasAvailableSizePrice ? null : this.selectedIngredient;
        this.ingredientChange.emit(this.selectedIngredient);
      }
    }
  }

  onIngredientChange(event: string) {
    this.selectedIngredient = this.unsatisfiedIngredientChoice.ingredients.find(i => i.name === event);
    this.hasQualifiers = this.selectedIngredient.qualifiers.length > 0;
    this.qualifiers = [];
    this.qualifiers = this.getDefaultQualifiers(this.selectedIngredient);
    this.orderableQualifiers = this.getDefaultQualifiers(this.selectedIngredient, true);
    this.ingredientChange.emit(this.selectedIngredient);
    this.qualifierChange.emit(this.qualifiers);
  }

  onQualifierChange(orderableQualifier: OrderableQualifier) {
    if (!!this.qualifiers.find(q => q === orderableQualifier.name)) {
      this.orderableQualifiers = this.orderableQualifiers.filter(q => q !== orderableQualifier);
      this.qualifiers = this.qualifiers.filter(q => q !== orderableQualifier.name);
    } else {
      const sameGroupQualifierIndex = this.qualifiers
        .map(qualifier => this.orderableQualifiers.find(q => q.name === qualifier))
        .findIndex(q => !!q && q.type === orderableQualifier.type);
      if (sameGroupQualifierIndex >= 0) {
        this.qualifiers.splice(sameGroupQualifierIndex, 1);
        this.orderableQualifiers.splice(sameGroupQualifierIndex, 1);
        this.qualifiers.push(orderableQualifier.name);
        this.orderableQualifiers.push(orderableQualifier);
      } else {
        this.qualifiers.push(orderableQualifier.name);
        this.orderableQualifiers.push(orderableQualifier);
      }
    }
    this.qualifiers = this.qualifiers.slice(0);
    this.qualifierChange.emit(this.qualifiers);
  }

  getDefaultQualifiers(selectedIngredient: OrderableIngredient, getOrderableQualifier?: boolean) {
    const qualifiers = [];
    const orderableQualifier = [];
    if (selectedIngredient && selectedIngredient.qualifiers.length > 0) {
      selectedIngredient.qualifiers.forEach(q => {
        if (q.isDefault) {
          qualifiers.push(q.name);
          orderableQualifier.push(q);
        }
      });
    }
    return getOrderableQualifier ? orderableQualifier : qualifiers;
  }
}
